import {
  SourcingExternalGeneratingSearchStep,
  SourcingExternalSearchStep,
  SourcingExternalSelectedCandidatesStep,
  SourcingExternalChooseChannelStep,
  SourcingExternalJobInformationStep,
  SourcingExternalSetupApplicationStep,
  SourcingExternalCustomizeMessageStep,
  SourcingExternalReviewInvitationsStep,
  SourcingExternalSuccessStep
} from 'modules/sourcing-external/steps';
import { SHARED_SOURCING_STEPS } from 'modules/sourcing-shared/shared-stores/step-components';

const steps = [
  'GENERATING_SEARCH',
  'SEARCH',
  ...SHARED_SOURCING_STEPS
] as const;
export type SourcingExternalStep = (typeof steps)[number];

type SourcingExternalStepComponent = {
  [K in SourcingExternalStep]: React.ComponentType;
};

export const sourcingExternalStepComponents: SourcingExternalStepComponent = {
  GENERATING_SEARCH: SourcingExternalGeneratingSearchStep,
  SEARCH: SourcingExternalSearchStep,
  SELECTED_CANDIDATES: SourcingExternalSelectedCandidatesStep,
  CHOOSE_CHANNEL: SourcingExternalChooseChannelStep,
  JOB_INFORMATION: SourcingExternalJobInformationStep,
  SETUP_APPLICATION: SourcingExternalSetupApplicationStep,
  CUSTOMIZE_MESSAGE: SourcingExternalCustomizeMessageStep,
  REVIEW_INVITATIONS: SourcingExternalReviewInvitationsStep,
  SUCCESS: SourcingExternalSuccessStep
};
